function startCountdownTimer() {

    const timers = document.querySelectorAll('.u-timer-block');
    if (!timers.length) return;

    timers.forEach(function (timer) {

        const totalDays = parseInt(timer.dataset.days) || 1;

        function getEndTime() {
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);

        return new Date(
            midnight.getTime() + (totalDays - 1) * 24 * 60 * 60 * 1000
        );
        }

        let endTime = getEndTime();

        function updateTimer() {
        const now = new Date();
        let diff = endTime - now;

        if (diff <= 0) {
            endTime = getEndTime();
            diff = endTime - now;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        diff %= (1000 * 60 * 60 * 24);

        const hours = Math.floor(diff / (1000 * 60 * 60));
        diff %= (1000 * 60 * 60);

        const minutes = Math.floor(diff / (1000 * 60));
        diff %= (1000 * 60);

        const seconds = Math.floor(diff / 1000);

        timer.querySelector('[data-days-value]').textContent = String(days).padStart(2, '0');
        timer.querySelector('[data-hours-value]').textContent = String(hours).padStart(2, '0');
        timer.querySelector('[data-minutes-value]').textContent = String(minutes).padStart(2, '0');
        timer.querySelector('[data-seconds-value]').textContent = String(seconds).padStart(2, '0');
        }

        updateTimer();
        setInterval(updateTimer, 1000);
    });
    }

    document.addEventListener('DOMContentLoaded', startCountdownTimer);
    document.addEventListener('shopify:section:load', startCountdownTimer);